package shared.ui.components

import kotlinx.html.*

object ComingSoon {
    fun render(parent: DIV, featureName: String, emoji: String) {
        parent.div("text-center py-12") {
            div("text-6xl mb-4") { +emoji }
            h3("text-xl font-bold mb-2") { +"$featureName Coming Soon" }
            p("text-slate-400") { +"This feature is currently under development" }
        }
    }
}
